<template>
    <div class="container max-w-3xl mx-auto">
        <div class="pt-4 pb-16 xl:pt-8 md:pb-20 xl:pb-24">
            <div class="md:text-center">
                <h1 class="max-w-lg mx-auto mb-4 text-3xl font-semibold leading-tight tracking-tight font-noto-sans xs:text-4xl md:text-5xl lg:text-6xl text-grey-darkest">
                    Switching Service<br>
                    <span class="text-blue">for landlords &amp; agents</span>
                </h1>

                <h2 class="max-w-md mx-auto mb-6 lg:mb-12 md:text-xl xl:text-2xl">
                    We’ll help you switch to Rentora from your current agent or letting software - and it won’t cost you a penny.
                </h2>
            </div>

            <div class="max-w-sm mx-auto">
                <div class="flex flex-col justify-center mb-4 md:flex-row">
                    <laroute-link
                        :to="{
                            name: 'auth.users.create'
                        }"
                        class="flex-auto mb-3 shadow-md md:mb-0 md:mr-3 btn btn-blue btn-xl"
                    >
                        Get started
                    </laroute-link>

                    <callback-requests-create-button
                        class="flex-auto shadow-md btn btn-white btn-xl"
                    >
                        Request a callback
                    </callback-requests-create-button>
                </div>

                <router-link
                    :to="{ name: 'www.tenants.index' }"
                    class="flex items-center font-semibold text-blue"
                >
                    Are you a tenant?

                    <base-svg
                        name="icon-cheveron-right"
                        class="flex-none w-6 h-6 fill-primary-blue"
                    />
                </router-link>
            </div>
        </div>

        <grid-layout class="pb-6 md:pb-12 lg:pb-16 xl:pb-32">
            <grid-layout-item class="mb-12 lg:mb-0 lg:w-1/3">
                <div class="inline-block p-3 mb-4 rounded-full md:mb-0 border-3 border-blue-lighter">
                    <base-svg
                        name="icon-fast-forward"
                        class="w-8 h-8 fill-primary-blue fill-secondary-blue-lighter"
                    />
                </div>

                <h6 class="mb-2 text-lg font-semibold font-noto-sans text-grey-darkest">
                    Fast, tailored agent switching
                </h6>

                <div class="mb-1 text-sm italic text-blue">
                    Included
                </div>

                <p class="mb-3">
                    Each switch is different and will be tailored to you and your needs.
                </p>

                <p>
                    We'll advise and assist you in notifying your existing provider of your intention to leave, before completing the rest of the process for you.
                </p>
            </grid-layout-item>

            <grid-layout-item class="mb-12 lg:mb-0 lg:w-1/3">
                <div class="inline-block p-3 mb-4 rounded-full md:mb-0 border-3 border-blue-lighter">
                    <base-svg
                        name="icon-application"
                        class="w-8 h-8 fill-primary-blue-lighter fill-secondary-blue"
                    />
                </div>

                <h6 class="mb-2 text-lg font-semibold font-noto-sans text-grey-darkest">
                    Software switcher
                </h6>

                <div class="mb-1 text-sm italic text-blue">
                    Included
                </div>

                <p>
                    We’ll also help you switch to Rentora from other services. It doesn’t matter if you’re using different solutions for rent collection, inventories, etc - we’ll collate all of your data and import it into your Rentora account for you.
                </p>
            </grid-layout-item>

            <grid-layout-item class="mb-12 lg:mb-0 lg:w-1/3">
                <div class="inline-block p-3 mb-4 rounded-full md:mb-0 border-3 border-blue-lighter">
                    <base-svg
                        name="icon-phone-ring"
                        class="w-8 h-8 fill-primary-blue-lighter fill-secondary-blue"
                    />
                </div>

                <h6 class="mb-2 text-lg font-semibold font-noto-sans text-grey-darkest">
                    We can help today
                </h6>

                <div class="mb-1 text-sm italic text-blue">
                    Included
                </div>

                <p class="mb-3">
                    Our experts are ready to help you make the switch today.
                </p>

                <p>
                    <router-link
                        :to="{
                            name: 'www.contact.index'
                        }"
                        class="text-blue"
                    >
                        Give us a call,
                    </router-link>
                    and together we'll figure out what's best for you.
                </p>
            </grid-layout-item>
        </grid-layout>

        <div class="flex flex-col items-center max-w-xl p-3 mx-auto mb-24 rounded lg:flex-row xs:p-6 lg:p-12 bg-blue-lightest">
            <div class="mb-6 lg:mb-0 lg:w-1/2">
                <h6 class="text-2xl font-semibold md:text-3xl font-noto-sans text-blue-darkest">
                    Ready to switch?
                </h6>

                <p class="text-lg lg:text-xl">
                    Create an account in a couple of minutes
                </p>
            </div>

            <div class="flex flex-col justify-center w-full lg:w-1/2 md:flex-row lg:justify-end">
                <laroute-link
                    :to="{
                        name: 'auth.users.create'
                    }"
                    class="w-full mb-3 shadow-md md:mb-0 md:mr-3 md:w-auto btn btn-blue-darkest btn-xl"
                >
                    Get started
                </laroute-link>

                <callback-requests-create-button
                    class="w-full shadow-md md:w-auto btn btn-white btn-xl"
                >
                    Request a callback
                </callback-requests-create-button>
            </div>
        </div>
    </div>
</template>

<script>
    import HeadMixin from '../../../../mixins/head'

    export default {
        mixins: [
            HeadMixin
        ],
        methods: {
            head () {
                return {
                    title: [
                        'Switching Service',
                        'Free switching from your existing agent or software'
                    ]
                }
            }
        }
    }
</script>
